// src/components/LayoutWithNavbar.tsx
import React from "react";
import { useLocation } from "react-router-dom";
import NavBar from "../navbar/navbar";

interface Props {
  children: React.ReactNode;
}

const LayoutWithNavbar: React.FC<Props> = ({ children }) => {
  return (
    <>
      {<NavBar />}
      {children}
    </>
  );
};

export default LayoutWithNavbar;
